import React, { useEffect, useRef, useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { registerReasonPrompt } from '../services/reasonBridge';

// "¿Por qué?" — asked of a sales user before a request to modify or delete something goes to the admins (the server
// requires it: 428 REASON_REQUIRED, see services/api.js). Mounted once in App.js.
const MIN = 3;
const MAX = 300;

const ReasonPrompt = () => {
  const [ask, setAsk] = useState(null); // what is being asked, while the dialog is open
  const [reason, setReason] = useState('');
  const resolver = useRef(null);

  useEffect(() => registerReasonPrompt((what) => new Promise((resolve) => {
    resolver.current = resolve;
    setReason('');
    setAsk(what || 'esta acción');
  })), []);

  const close = (value) => {
    const resolve = resolver.current;
    resolver.current = null;
    setAsk(null);
    if (resolve) resolve(value);
  };
  const text = reason.trim();

  return (
    <Modal show={ask !== null} onHide={() => close(null)} centered>
      <Modal.Header closeButton><Modal.Title>Motivo de la solicitud</Modal.Title></Modal.Header>
      <Modal.Body>
        <div className="mb-2">Vas a pedir aprobación para <strong>{ask}</strong>. ¿Por qué? El administrador lo verá antes de decidir.</div>
        <Form.Control as="textarea" rows={3} autoFocus maxLength={MAX} value={reason} placeholder="Ej.: el cliente pidió anularla porque…"
          onChange={e => setReason(e.target.value)}
          onKeyDown={e => { if (e.key === 'Enter' && (e.metaKey || e.ctrlKey) && text.length >= MIN) close(text); }} />
        <div className="small text-muted mt-1">{text.length}/{MAX}</div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={() => close(null)}>Cancelar</Button>
        <Button disabled={text.length < MIN} onClick={() => close(text)}>Pedir aprobación</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ReasonPrompt;
